angular.module('satv.playlist.pitch')
.controller('PlaylistPitchCtrl', ['$scope', '$controller', 'PitchModal', 'playlistLoader', function ($scope, $controller, PitchModal, playlistLoader) {
    'use strict';

    angular.extend(this, $controller('PlaylistsCtrl', {
        $scope: $scope,
        playlistLoader: playlistLoader
    }));

    $scope.pitch = function(playlist) {
        PitchModal.open({
            success: function() {
                playlist.pitch_count++;
                playlistLoader.getFirstPage();
            }
        }, {
            playlist: playlist
        });
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/controllers/PlaylistPitchCtrl.js